import validate from "/root/front/node_modules/.pnpm/nuxt@4.0.2_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@24.1.0_@vue+compiler-_0531694196dc456235df74f6ff64da10/node_modules/nuxt/dist/pages/runtime/validate.js";
import _01_45band_45select_45global from "/root/front/app/middleware/01.bandSelect.global.ts";
import _02_45reset_45draft_45global from "/root/front/app/middleware/02.resetDraft.global.ts";
import _03_45redirect_45routes_45with_45locale_45prefix_45global from "/root/front/app/middleware/03.redirectRoutesWithLocalePrefix.global.ts";
import _04_45utm_45global from "/root/front/app/middleware/04.utm.global.ts";
export const globalMiddleware = [
  validate,
  _01_45band_45select_45global,
  _02_45reset_45draft_45global,
  _03_45redirect_45routes_45with_45locale_45prefix_45global,
  _04_45utm_45global
]
export const namedMiddleware = {
  "draft-id": () => import("/root/front/app/middleware/draftId.ts"),
  "draft-influencers": () => import("/root/front/app/middleware/draftInfluencers.ts"),
  "draft-shared-music": () => import("/root/front/app/middleware/draftSharedMusic.ts"),
  "draft-step": () => import("/root/front/app/middleware/draftStep.ts"),
  "get-cart-and-favorites": () => import("/root/front/app/middleware/getCartAndFavorites.ts"),
  "index-redirection": () => import("/root/front/app/middleware/indexRedirection.ts"),
  "influencer-dashboard": () => import("/root/front/app/middleware/influencerDashboard.ts"),
  "is-agency": () => import("/root/front/app/middleware/isAgency.ts"),
  "is-band": () => import("/root/front/app/middleware/isBand.ts"),
  "is-influencer": () => import("/root/front/app/middleware/isInfluencer.ts"),
  "is-logged-in": () => import("/root/front/app/middleware/isLoggedIn.ts"),
  "onboarding-flow": () => import("/root/front/app/middleware/onboardingFlow.ts"),
  "progressive-promos-check": () => import("/root/front/app/middleware/progressivePromosCheck.ts"),
  "redirect-missing-id-param": () => import("/root/front/app/middleware/redirectMissingIdParam.ts"),
  "tag-fetch": () => import("/root/front/app/middleware/tagFetch.ts")
}